export default __webpack_public_path__ + "static/media/2412308.b67a7918.webp";